export function resolveRequestUrl(config = {}) {
  const url = config.url || '';
  const baseURL = config.baseURL || '';

  if (!url) {
    return '';
  }

  if (/^https?:\/\//i.test(url)) {
    return url;
  }

  if (baseURL) {
    return `${String(baseURL).replace(/\/$/, '')}/${String(url).replace(/^\//, '')}`;
  }

  return url;
}

export function getRequestPath(config = {}) {
  const resolvedUrl = resolveRequestUrl(config);

  try {
    const parsed = /^https?:\/\//i.test(resolvedUrl)
      ? new URL(resolvedUrl)
      : new URL(resolvedUrl, 'http://local.invalid');
    return parsed.pathname;
  } catch {
    return resolvedUrl;
  }
}

export function isLoginRequest(config = {}) {
  return getRequestPath(config).endsWith('/login');
}

export function isLogoutRequest(config = {}) {
  return getRequestPath(config).endsWith('/logout');
}

export function shouldAttachAuthToken(config = {}) {
  return !config.skipAuth && !isLoginRequest(config);
}

export function getUnauthorizedRecovery({ status, config = {}, currentPath = '' } = {}) {
  if (status !== 401) {
    return 'ignore';
  }

  if (config.skipUnauthorizedRedirect || isLoginRequest(config) || isLogoutRequest(config)) {
    return 'ignore';
  }

  if (typeof currentPath === 'string' && currentPath.startsWith('/m/')) {
    return 'mobile';
  }

  return 'desktop';
}
